import colors from '../../styles/colors.js';

export default colors;
